export const PERMS = {
    READ: 'company_bank_accounts.read',
    UPDATE: 'company_bank_accounts.update',
    DELETE: 'company_bank_accounts.delete',
    CREATE: 'company_bank_accounts.create',
}
